import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import './ReservationsListContainer.css'
import { Container, Row, Col } from 'reactstrap'
import { RepsQuery } from '../Functions/querys'
import { AllCarLocations } from './ReservationQueries'
import ReservationsList from '../CA/ReservationsList'
import { AllAgreementTypes } from './ReservationQueries'
import ReservationsListHeader from '../CA/ReservationsListHeader'

import withApolloClient from '../withApolloClient'
export const PRESETS = []

class AllReservationsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-driver__in_office"],
            },
            selectedDrivers: [],
            refetchReservations: false,
            presets: PRESETS,
            defaultPresets: PRESETS,
        }
    }

    setPresets = (presets) => this.setState({ presets })
    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }
    render() {
        return (
            <div className="ReservationsListContainer">
                <Container fluid>
                    <ReservationsListHeader
                        activeTab="all"
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        selectedDrivers={this.state.selectedDrivers} history={this.props.navigate} location={this.props.location}
                        resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                        refetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                        presets={this.state.presets}
                        setPresets={this.setPresets}
                        defaultPresets={this.state.defaultPresets}
                    />
                    <Row>
                        <Col>
                            <ReservationsList
                                currentUser={this.props.currentUser}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                presets={this.state.presets}
                                selectedTab="all"
                                selectedDrivers={this.state.selectedDrivers}
                                setSelectedDrivers={(selectedDrivers) => this.setState({ selectedDrivers })}
                                refetchReservations={this.state.refetchReservations}
                                setRefetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}


//-----------------------------------
export default graphql(RepsQuery, {
    options: { fetchPolicy: 'cache-first' },
    props: ({ data: { allReps } }) => ({
        allReps,
    }),
})(
    graphql(AllAgreementTypes, {
        props: ({ data: { allAgreementTypes } }) => ({
            allAgreementTypes,
        }),
    })(
        graphql(AllCarLocations, {
            props: ({ data: { allCarLocations } }) => ({
                allCarLocations,
            }),
        })(
            withApolloClient(AllReservationsListContainer)
        )
    )
);

